<template>
  <div class="content" ref="content">
    <div class="changeSchool" ref="select">
      <span>{{ $t('admin.analysis.teacher.school.label') }}</span>
      <a-select
        v-model="schoolId"
        :placeholder="$t('admin.analysis.teacher.school.placeholder')"
        style="width: 120px"
        @change="getData"
        class="select"
        :getPopupContainer="getPopupContainer">
        <a-select-option :value="item.id" v-for="item of schooldList" :key="item"> {{ item.name }} </a-select-option>
      </a-select>
      <a-icon type="fullscreen-exit" class="icon" @click="toggleFullscreen(false)" v-if="isFullscreen"/>
      <a-icon type="fullscreen" class="icon" @click="toggleFullscreen(true)" v-else/>
    </div>
    <div class="card structure">
      <div class="headline">
        <div class="title">{{ $t('admin.analysis.teacher.title') }}</div>
      </div>
      <div class="detail">
        <div>
          <div class="list">
            <img src="@/assets/img/woman_teacher.png" alt="" />
            <div class="name">
              <div>{{ $t('admin.analysis.teacher.gender.female') }}</div>
              <div><span>{{ womanCount }}</span><span> {{ $t('admin.analysis.teacher.gender.unit') }}</span></div>
            </div>
          </div>
          <div class="list">
            <img src="@/assets/img/man_teacher.png" alt="" />
            <div class="name">
              <div>{{ $t('admin.analysis.teacher.gender.male') }}</div>
              <div><span>{{ manCount }}</span><span> {{ $t('admin.analysis.teacher.gender.unit') }}</span></div>
            </div>
          </div>
        </div>
        <div class="echatrContent">
          <div ref="echartTitle"></div>
          <div ref="echartEdu"></div>
          <div ref="echartAge"></div>
          <div ref="echartMajor"></div>
        </div>
      </div>
      <a-spin class="loading" v-if="structureLoading"></a-spin>
    </div>
    <div class="card capacity">
      <div class="headline">
        <div class="title">{{ $t('admin.analysis.teacher.ability.title') }}</div>
      </div>
      <div class="detail" ref="echartCapacity"></div>
    </div>
    <div class="card teach">
      <div class="headline">
        <div class="title">{{ $t('admin.analysis.teacher.teaching.title') }}</div>
      </div>
      <div class="detail">
        <div class="num">
          <div class="pk">
            <div
              :style="{
                width: (teacherCount * 100) / (teacherCount + studentCount) + '%'
              }"
            ></div>
          </div>
          <div class="amount">
            <div>{{ $t('admin.analysis.teacher.ability.teacherCount') }}({{ teacherCount }})</div>
            <div>{{ $t('admin.analysis.teacher.ability.studentCount') }}({{ studentCount }})</div>
          </div>
        </div>
        <div class="data">
          <div class="list">
            <img src="@/assets/img/ready_lesson.png" alt="" />
            <div class="name">
              <div>{{ $t('admin.analysis.teacher.teaching.prepCount') }}</div>
              <div><span>{{ prepareLessonCount }}</span><span> {{ $t('admin.analysis.teacher.teaching.unit') }}</span></div>
            </div>
          </div>
          <div class="list">
            <img src="@/assets/img/play_lesson.png" alt="" />
            <div class="name">
              <div>{{ $t('admin.analysis.teacher.teaching.teachingCount') }}</div>
              <div><span>{{ teachingCount }}</span><span> {{ $t('admin.analysis.teacher.teaching.unit') }}</span></div>
            </div>
          </div>
          <div class="list">
            <img src="@/assets/img/play_control.png" alt="" />
            <div class="name">
              <div>{{ $t('admin.analysis.teacher.teaching.controlCount') }}</div>
              <div><span>{{ playCount }}</span><span> {{ $t('admin.analysis.teacher.teaching.unit') }}</span></div>
            </div>
          </div>
        </div>
        <div ref="echartTeach"></div>
      </div>
    </div>
    <div class="card analyse">
      <div class="headline">
        <div class="title">{{ $t('admin.analysis.teacher.analysis.title') }}</div>
        <div class="desc">
          <span>{{ $t('admin.analysis.teacher.analysis.stats.teachers') }}：</span>
          <span>{{ lectureTeacherCount }}</span>
          <span>{{ $t('admin.analysis.teacher.analysis.stats.unit.person') }}</span>
          <span>{{ $t('admin.analysis.teacher.analysis.stats.totalHours') }}：</span>
          <span>{{ classHourCount }}</span>
          <span>{{ $t('admin.analysis.teacher.analysis.stats.unit.hour') }}</span>
          <span>{{ $t('admin.analysis.teacher.analysis.stats.avgHours') }}：</span>
          <span>{{ classHourPerPerson }}</span>
          <span>{{ $t('admin.analysis.teacher.analysis.stats.unit.hour') }}</span>
        </div>
      </div>
      <div class="detail">
        <div ref="echartResource"></div>
        <div ref="echartLesson"></div>
      </div>
    </div>
    <div class="card assess">
      <div class="headline">
        <div class="title">{{ $t('admin.analysis.teacher.assessment.title') }}</div>
        <div class="desc">
          <span>{{ $t('admin.analysis.teacher.assessment.stats.teachers') }}：</span>
          <span>{{ examineTeacherCount }}</span>
          <span>{{ $t('admin.analysis.teacher.assessment.stats.unit.person') }}</span>
          <span>{{ $t('admin.analysis.teacher.assessment.stats.duration') }}：</span>
          <span>{{ examineTime }}</span>
          <span>{{ $t('admin.analysis.teacher.assessment.stats.unit.hour') }}</span>
          <span>{{ $t('admin.analysis.teacher.assessment.stats.count') }}：</span>
          <span>{{ examineCount }}</span>
          <span>{{ $t('admin.analysis.teacher.assessment.stats.unit.times') }}</span>
        </div>
      </div>
      <div class="detail">
        <div ref="echartPaper"></div>
        <div ref="echartLab"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { teacherStruct, teacherAbility, lectureAnalyse, examineAnalyse, teachingAbility } from '@/api/chart.js'
import { collegeList } from '@/api/admin.js'

export default {
  data() {
    return {
      isFullscreen: false,
      schoolId: '0',
      schooldList: [],
      structureLoading: false,
      manCount: 0,
      womanCount: 0,
      teacherCount: 10,
      studentCount: 100,
      prepareLessonCount: 0,
      teachingCount: 0,
      playCount: 0,
      lectureTeacherCount: 0,
      classHourCount: 0,
      classHourPerPerson: 0,
      examineTeacherCount: 0,
      examineTime: 0,
      examineCount: 0,
      colorGather: ['#3076F3', '#48B4FF', '#FDE076', '#43C391', '#FD9A4A', '#FFBA28', '#6B80DB', '#17BDBC', '#FF8B8A', '#9690FA']
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getPopupContainer() {
      return this.$refs.select
    },
    initEcharts() {
      this.initEchartsTitle()
      this.initEchartsEdu()
      this.initEchartsAge()
      this.initEchartsMajor()
      this.initEchartsAbility()
      this.initEchartsTeach()
      this.initEchartsResource()
      this.initEchartsLesson()
      this.initEchartsPaper()
      this.initEchartsLab()
    },
    // 初始化职称分布echarts
    initEchartsTitle(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.distribution.ranks.senior') },
        { value: 5, name: this.$t('admin.analysis.teacher.distribution.ranks.fullSenior') },
        { value: 15, name: this.$t('admin.analysis.teacher.distribution.ranks.firstLevel') },
        { value: 25, name: this.$t('admin.analysis.teacher.distribution.ranks.secondLevel') },
        { value: 20, name: this.$t('admin.analysis.teacher.distribution.ranks.thirdLevel') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#FD9A4A', '#FDE076', '#6287FD', '#43C391', '#FD9A4A', '#FFBA28', '#6B80DB', '#17BDBC', '#FF8B8A', '#9690FA']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })

      this.echartTitle = echarts.init(this.$refs.echartTitle)
      const optionTitle = {
        title: {
          text: this.$t('admin.analysis.teacher.distribution.title'),
          left: 'center',
          top: '33%',
          // 大小12px
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.distribution.title'),
            type: 'pie',
            radius: [30, 50],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            labelLine: {
              show: false
            },
            center: ['50%', '40%'],
            data,
            emphasis: {
              scaleSize: 1
            }
          }
        ]
      }
      this.echartTitle.setOption(optionTitle)
    },
    // 初始化老师学历echarts
    initEchartsEdu(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.education.levels.primary') },
        { value: 5, name: this.$t('admin.analysis.teacher.education.levels.junior') },
        { value: 15, name: this.$t('admin.analysis.teacher.education.levels.senior') },
        { value: 25, name: this.$t('admin.analysis.teacher.education.levels.college') },
        { value: 20, name: this.$t('admin.analysis.teacher.education.levels.bachelor') },
        { value: 20, name: this.$t('admin.analysis.teacher.education.levels.master') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#48B4FF', '#17BDBC', '#6287FD', '#43C391', '#FDE076', '#A371DA']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartEdu = echarts.init(this.$refs.echartEdu)
      const optionEdu = {
        title: {
          text: this.$t('admin.analysis.teacher.education.title'),
          left: 'center',
          top: '33%',
          // 大小12px
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.education.title'),
            type: 'pie',
            radius: [30, 50],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
            },
            center: ['50%', '40%'],
            data
          }
        ]
      }
      this.echartEdu.setOption(optionEdu)
    },
    // 初始化老师年龄age
    initEchartsAge(data = []) {
      const dataDefault = [
        { value: 10, name: '20-29' },
        { value: 5, name: '30-39' },
        { value: 15, name: '40-49' },
        { value: 25, name: '50-59' },
        { value: 20, name: '60-69' },
        { value: 25, name: '70-79' },
        { value: 20, name: '80-100' }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#17BDBC', '#FF9C28', '#48B4FF', '#FFC128', '#6287FD', '#43C391', '#FDE076']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartAge = echarts.init(this.$refs.echartAge)
      const optionAge = {
        title: {
          text: this.$t('admin.analysis.teacher.age.title'),
          left: 'center',
          top: '33%',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.age.title'),
            type: 'pie',
            radius: [30, 50],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
            },
            center: ['50%', '40%'],
            data
          }
        ]
      }
      this.echartAge.setOption(optionAge)
    },
    // 初始化专业分布
    initEchartsMajor(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.major.industries.robot') },
        { value: 5, name: this.$t('admin.analysis.teacher.major.industries.machine') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartMajor = echarts.init(this.$refs.echartMajor)
      const optionMajor = {
        title: {
          text: this.$t('admin.analysis.teacher.major.title'),
          left: 'center',
          top: '33%',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.major.title'),
            type: 'pie',
            radius: [30, 50],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
            },
            center: ['50%', '40%'],
            data
          }
        ]
      }
      this.echartMajor.setOption(optionMajor)
    },
    // 初始化老师能力
    initEchartsAbility(list = []) {
      let value = [4000, 10000, 28000, 35000, 50000, 19000]
      let indicator = [
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.teaching'), max: 6500 },
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.technology'), max: 16000 },
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.attitude'), max: 30000 },
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.management'), max: 38000 },
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.research'), max: 52000 },
          { name: this.$t('admin.analysis.teacher.charts.ability.indicators.assessment'), max: 25000 }
      ]
      let allNum = 100000

      if (list.length > 0) {
        value = list.map(item => item.value)
        allNum = list[0].max
        indicator = list.map(item => ({
          name: item.name,
          max: item.max
        }))
      }

      this.echartCapacity = echarts.init(this.$refs.echartCapacity)
      const optionCapacity = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: function (params) {
            var content = `${params.seriesName}<br/>`
            for (var i = 0; i < params.value.length; i++) {
                const ratio = (params.value[i] / allNum * 100).toFixed(2)
                content += `${optionCapacity.radar.indicator[i].name}: ${ratio}%<br/>`
            }
            return content
          }
        },
        radar: {
          // shape: 'circle',
          // radius: '60%',
          startAngle: 120,
          name: {
            textStyle: {
              color: '#000'
            }
          },
          indicator
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.teacher.teacherAbility'),
            type: 'radar',
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: 'rgba(254, 151, 36, 0.23)'
            },
            lineStyle: {
              color: '#FEA91B'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(211, 253, 250, 0.8)'
              }
            },
            itemStyle: {
              color: '#FF8500'
            },
            // areaStyle: {normal: {}},
            data: [
              {
                value
              }
            ]
          }
        ]
      }
      this.echartCapacity.setOption(optionCapacity)
    },
    // 初始化教学能力
    initEchartsTeach(list = []) {
      let xAxisData = [this.$t('dataAnalysis.synthesis.teachers.wang'), this.$t('dataAnalysis.synthesis.teachers.zhang'), this.$t('dataAnalysis.synthesis.teachers.li'), this.$t('dataAnalysis.synthesis.teachers.liu'), this.$t('dataAnalysis.synthesis.teachers.sun')]
      let seriesDataPrepare = [120, 332, 301, 334, 390]
      let seriesDataTeach = [320, 332, 301, 334, 390]
      let seriesDataPlay = [220, 332, 301, 334, 390]
      if (list.length > 0) {
        xAxisData = []
        seriesDataPrepare = []
        seriesDataTeach = []
        seriesDataPlay = []
        list.forEach(item => {
          xAxisData.push(item.name)
          seriesDataPrepare.push(item.data.find(itemData => itemData.type === this.$t('dataAnalysis.teacher.preparation')).value)
          seriesDataTeach.push(item.data.find(itemData => itemData.type === this.$t('dataAnalysis.teacher.teaching')).value)
          seriesDataPlay.push(item.data.find(itemData => itemData.type === this.$t('dataAnalysis.teacher.broadcasting')).value)
        })
      }
      this.echartTeach = echarts.init(this.$refs.echartTeach)
      const optionTeach = {
        legend: {},
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
        },
        grid: {
          top:'15%',
          left: '6%', // 调整左边距
          right: '10%', // 调整右边距
          bottom: '25%' // 调整下边距
        },
        xAxis: {
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626'
            }
          },
          axisLine: {
            //x轴线的颜色以及宽度
            show: true,
            lineStyle: {
              color: '#868686',
              width: 0,
              type: 'solid'
            }
          },
          nameTextStyle: {
            align: 'right',
            lineHeight: '28',
            verticalAlign: 'top'
          },
          type: 'category',
          name: this.$t('dataAnalysis.synthesis.other.teacherName'),
          axisTick: { show: false },
          data: xAxisData
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          name: this.$t('dataAnalysis.synthesis.other.quantity'),
          nameTextStyle: { color: '#868686' },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626'
            }
          },
          axisLine: {
            //x轴线的颜色以及宽度
            show: false
          }
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 12,
          data: [
            this.$t('admin.analysis.teacher.charts.legend.prep'),
            this.$t('admin.analysis.teacher.charts.legend.teaching'),
            this.$t('admin.analysis.teacher.charts.legend.control')
          ]
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.prep'),
            type: 'bar',
            data: seriesDataPrepare,
            itemStyle: { color: '#07CEB2' }
          },
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.teaching'),
            type: 'bar',
            data: seriesDataTeach,
            itemStyle: { color: '#FFB641' }
          },
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.control'),
            type: 'bar',
            data: seriesDataPlay,
            itemStyle: { color: '#2886FF' }
          }
        ]
      }
      this.echartTeach.setOption(optionTeach)
    },
    // 初始化资源使用次数
    initEchartsResource(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 35, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#6287FD', '#17BDBC', '#48B4FF', '#FD9A4A', '#43C391', '#FFBA28']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartResource = echarts.init(this.$refs.echartResource)
      const optionResource = {
        title: {
          text: this.$t('admin.analysis.teacher.charts.series.name.resourceUsage'),
          top: '80%',
          textStyle: {
            fontSize: 14
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 12,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.resourceUsage'),
            type: 'pie',
            radius: [45, 110],
            top: '-20%',
            label: {
              show: false
            },
            emphasis: {
            },
            data
          }
        ]
      }
      this.echartResource.setOption(optionResource)
    },
    // 初始化各专业开课占比
    initEchartsLesson(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.charts.major.types.robot') },
        { value: 5, name: this.$t('admin.analysis.teacher.charts.major.types.cnc') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(4).concat(this.colorGather.slice(0, 4))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartLesson = echarts.init(this.$refs.echartLesson)
      const optionLesson = {
        title: {
          text: this.$t('admin.analysis.teacher.charts.series.name.majorCourses'),
          top: '80%',
          textStyle: {
            fontSize: 14
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 12,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.majorCourses'),
            type: 'pie',
            radius: [45, 110],
            top: '-20%',
            label: {
              show: false
            },
            emphasis: {
            },
            data
          }
        ]
      }
      this.echartLesson.setOption(optionLesson)
    },
    // 初始化布置试题占比
    initEchartsPaper(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.charts.questions.single') },
        { value: 5, name: this.$t('admin.analysis.teacher.charts.questions.multiple') },
        { value: 15, name: this.$t('admin.analysis.teacher.charts.questions.judge') },
        { value: 25, name: this.$t('admin.analysis.teacher.charts.questions.blank') },
        { value: 20, name: this.$t('admin.analysis.teacher.charts.questions.answer') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#48B4FF', '#6BC3DB', '#43C391', '#6B80DB', '#A7E125']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartPaper = echarts.init(this.$refs.echartPaper)
      const optionPaper = {
        title: {
          text: this.$t('admin.analysis.teacher.charts.series.name.examQuestions'),
          top: '80%',
          textStyle: {
            fontSize: 14
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 12,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.examQuestions'),
            type: 'pie',
            radius: [45, 110],
            top: '-20%',
            label: {
              show: false
            },
            emphasis: {
            },
            data
          }
        ]
      }
      this.echartPaper.setOption(optionPaper)
    },
    // 初始化布置实验占比
    initEchartsLab(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('admin.analysis.teacher.charts.major.types.robot') },
        { value: 5, name: this.$t('admin.analysis.teacher.charts.major.types.cnc') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(7).concat(this.colorGather.slice(0, 7))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartLab = echarts.init(this.$refs.echartLab)
      const optionLab = {
        title: {
          text: this.$t('admin.analysis.teacher.charts.series.name.experiments'),
          top: '80%',
          textStyle: {
            fontSize: 14
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10,
          left: 'center',
          top: 'bottom',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 12,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('admin.analysis.teacher.charts.series.name.experiments'),
            type: 'pie',
            radius: [45, 110],
            top: '-20%',
            label: {
              show: false
            },
            emphasis: {
            },
            data
          }
        ]
      }
      this.echartLab.setOption(optionLab)
    },
    getData() {
      const data = {
        orgId: this.schoolId === '0' ? null : this.schoolId
      }
      teacherStruct(data).then(res => {
        console.log(res)
        const data = res.data
        this.manCount = data.manCount
        this.womanCount = data.womanCount
        this.initEchartsTitle(data.rank)
        this.initEchartsEdu(data.education)
        this.initEchartsAge(data.age)
        this.initEchartsMajor(data.major)
      })
      teacherAbility(data).then(res => {
        this.initEchartsAbility(res.data.list)
      })
      teachingAbility(data).then(res => {
        const data = res.data
        this.studentCount = data.studentCount
        this.teacherCount = data.teacherCount
        this.prepareLessonCount = data.prepareLessonCount
        this.teachingCount = data.teachingCount
        this.playCount = data.playCount
        this.initEchartsTeach(data.chart)
      })
      lectureAnalyse(data).then(res => {
        const data = res.data
        this.initEchartsResource(data.resRate)
        this.initEchartsLesson(data.majorLessonRate)
        this.lectureTeacherCount = data.lectureTeacherCount
        this.classHourPerPerson = data.classHourPerPerson
        this.classHourCount = data.classHourCount
      })
      examineAnalyse(data).then(res => {
        const data = res.data
        this.initEchartsPaper(data.testPageRate)
        this.initEchartsLab(data.experimentRate)
        this.examineTeacherCount = data.examineTeacherCount
        this.examineTime = data.examineTime
        this.examineCount = data.examineCount
      })
    },
    async getSchooldData() {
      const res = await collegeList()
      this.schooldList = res.data.list
      this.schooldList.unshift({
        name: this.$t('admin.analysis.teacher.school.all'),
        id: '0'
      })
      console.log(res)
    },
    toggleFullscreen(status) {
      const content = this.$refs.content

      if (status) {
        this.enterFullscreen(content)
      } else {
        this.exitFullscreen()
      }
    },
    enterFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) { // Firefox
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) { // IE/Edge
        element.msRequestFullscreen()
      }
      this.isFullscreen = true
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen()
      }
      this.isFullscreen = false
    },
    onFullscreenChange() {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
      this.getData()
    }
  },
  mounted() {
    this.initEcharts()
    this.getData()
    this.timer = setInterval(() => {
      this.getData()
    }, 5 * 60000)
    this.getSchooldData()
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
    window.onresize = () => {
      this.echartTitle.resize()
      this.echartEdu.resize()
      this.echartAge.resize()
      this.echartMajor.resize()
      this.echartCapacity.resize()
      this.echartTeach.resize()
      this.echartResource.resize()
      this.echartLesson.resize()
      this.echartPaper.resize()
      this.echartLab.resize()
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="less">
.content {
  background-color: #f2f2f2 !important;
  height: 100%;
  padding: 18px 27px !important;
  .changeSchool{
    display: flex;
    align-items: center;
    .select /deep/ .ant-select-selection{
      border-radius: 20px;
    }
    .icon{
      margin-left: auto;
    }
  }
  .card {
    width: 32.666%;
    height: calc(50% - 18px);
    min-height: 440px;
    padding: 14px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 18px;
    float: left;
    margin-right: 1%;
    position: relative;
    .headline {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-weight: 600;
        font-size: 14px;
        color: #6b738c;
        position: relative;
        padding-left: 16px;
        &::after {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -6px;
          content: '';
          width: 4px;
          height: 12px;
          background: #6b738c;
          border-radius: 2px;
        }
      }
      .desc {
        span {
          font-weight: 500;
          font-size: 12px;
          color: #4d607a;
        }
        span:nth-child(3n + 1) {
          padding-left: 12px;
        }
        span:first-child {
          padding-left: 0;
        }
        span:nth-child(3n + 2) {
          font-size: 16px;
        }
      }
    }
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.65);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }
  .structure .detail {
    width: 100%;
    height: calc(100% - 30px);
    > div:nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 17px;
      .list {
        display: flex;
        align-items: center;
        img {
          width: 52px;
          margin-right: 12px;
        }
        > div {
          color: #585858;
          font-size: 12px;
          div:nth-child(2) {
            color: #000000;
            span:nth-child(1) {
              font-size: 16px;
            }
            span:nth-child(2) {
              font-size: 12px;
            }
          }
        }
      }
    }
    .echatrContent {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: calc(100% - 70px);
      margin-top: 10px;
      > div {
        width: 50%;
        height: 50%;
        margin-top: 0px;
      }
    }
  }
  .capacity .detail {
    width: 100%;
    height: calc(100% - 30px);
  }
  .teach {
    margin-right: 0;
    .detail {
      height: calc(100% - 30px);
      .num {
        margin-top: 17px;
        .pk {
          width: 100%;
          height: 18px;
          background: #43c391;
          border-radius: 9px;
          overflow: hidden;
          > div {
            width: 30%;
            height: 100%;
            // background-color: #FFA728;
            // clip-path: polygon(0 0, 98% 0, 100% 100%, 0% 100%);
            position: relative;
            margin-left: -2px;
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: #ffa728;
              transform: skewX(4deg);
              transform-origin: top left;
            }
            &::after {
              content: '';
              position: absolute;
              top: 0;
              right: 0;
              width: 1px; /* 设置斜边的宽度 */
              height: 100%;
              background-color: white; /* 斜边的颜色 */
              transform: skewX(7deg); /* 斜边角度 */
              transform-origin: top right;
            }
          }
        }
        .amount {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 9px;
          div {
            font-weight: 400;
            font-size: 12px;
            color: #4b6175;
            display: flex;
            align-items: center;
            &::before {
              content: '';
              width: 7px;
              height: 7px;
              background: #ffa728;
              border-radius: 2px;
              margin-right: 5px;
            }
          }
          div:nth-child(2)::before {
            background: #43c391;
          }
        }
      }
      .data {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 12px;
        .list {
          display: flex;
          align-items: center;
          img {
            width: 52px;
            margin-right: 12px;
          }
          > div {
            color: #585858;
            font-size: 12px;
            div:nth-child(2) {
              color: #000000;
              span:nth-child(1) {
                font-size: 16px;
              }
              span:nth-child(2) {
                font-size: 12px;
              }
            }
          }
        }
      }
      > div:nth-child(3) {
        width: 100%;
        height: calc(100% - 110px);
      }
    }
  }
  .analyse,
  .assess {
    width: 49.5%;
    height: calc(50% - 58px);
    min-height: 390px;
    .detail {
      width: 100%;
      height: calc(100% - 30px);
      display: flex;
      align-items: center;
      > div {
        width: 50%;
        height: 100%;
      }
    }
  }
  .assess{
    margin-right: 0;
  }
}
</style>
